module.exports = __webpack_public_path__ + "fannie-mae-card-bottom-left.1ifUNug6.png";